import * as React from 'react';
import thousands from 'thousands';
import './_app-sum.scss';
import {
  calculationComponentModel2,
  calculationComponentProps,
  calculationComponentState,
  ColumnDefinitions,
  ColumnTypeGroup,
  ColumnValue,
} from '../calculationComponents.types';
import { serializeComponent, getAsNumber, valueObject } from '../calculationComponents.helpers';
import EventService from '../calculationComponents.eventservice';

export interface ApplicationSumProps extends calculationComponentProps {
  budgetSummaryCellId: string;
  textValue: string;
  yearForThisComponent: string;
}

export interface ApplicationSumState extends calculationComponentState {
  applicationSum: string;
  jsonXmlInput: string;
}

export class ApplicationSum extends React.Component<ApplicationSumProps, ApplicationSumState> {
  private _label:string = "Sökt belopp"; //NOTE: FOET-116: for existing utlysningar, this value needs to exist since it was not set in epi server
  constructor(props: ApplicationSumProps) {
    super(props);

    this.state = {
      applicationSum: '0',
      jsonFields: '',
      isValid: true,
      jsonXmlInput: '',
    };
  }

  componentDidMount = () => {
    const { formElementName, formElementHeading } = this.props;

    EventService.subscribe(`cell-updated:${this.props.budgetSummaryCellId}`, (e: CustomEvent) => {
      const applicationSum = thousands(e.detail, ' ');
      this.setState({
        applicationSum: e.detail,
        jsonFields: serializeComponent(null, [[valueObject(applicationSum, true)]], null, this.props.textValue),
        jsonXmlInput: this._getSerializedXmlInputComponent(applicationSum),
      });
    });
  };

  _getSerializedXmlInputComponent = (applicationSum: string): string => {
    const { formElementName, textValue } = this.props;

    const mainHeading = textValue ? textValue : this._label;

    const model = calculationComponentModel2.Create(formElementName, mainHeading, this._label);

    const columnValues = [{ value: applicationSum }] as ColumnValue[];
    const columnTypeGroup = { isSum: true, columnValues } as ColumnTypeGroup;
    const columnTypeGroups = [columnTypeGroup] as ColumnTypeGroup[];
    model.columnDefinitions = { columnTypeGroups } as ColumnDefinitions;
    return JSON.stringify(model);
  };

  public render() {

    return (
      <div className="app-sum cc-component">
        <div className="app-sum__col1">{this.props.textValue}</div>
        <div className="app-sum__col2">{thousands(this.state.applicationSum, ' ')}</div>
        <input type="hidden" name={"__c_soktBelopp_year"+ this.props.yearForThisComponent}   value={getAsNumber(this.state.applicationSum)} />
        <input
          type="hidden"
          name={this.props.formElementName}
          id={this.props.formElementName}
          value={this.state.jsonFields}
        />
        <input
          data-isvalid={this.state.isValid}
          type="hidden"
          name={'__XmlInput' + this.props.formElementName}
          id={'__XmlInput' + this.props.formElementName}
          value={this.state.jsonXmlInput}
        />
      </div>
    );
  }
}
